module.exports = __webpack_public_path__ + "img/borderLargeBracesWhite.6aba633f.svg";